import { TrendUp, TrendDown, Warning, Info } from "@phosphor-icons/react";

const TONE = {
  up: { icon: TrendUp, cls: "border-green-500 bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400" },
  down: { icon: TrendDown, cls: "border-red-500 bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400" },
  warn: { icon: Warning, cls: "border-yellow-500 bg-yellow-50 text-yellow-700 dark:bg-yellow-900/20 dark:text-yellow-400" },
  info: { icon: Info, cls: "border-blue-400 bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400" },
};

export default function BiInsights({ insights }) {
  if (!insights?.length) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2" data-testid="bi-insights">
      {insights.map((i, idx) => {
        const t = TONE[i.tone] || TONE.info;
        const Icon = t.icon;
        return (
          <div key={`${i.tone}-${i.text}`} className={`border-l-4 px-3 py-2 text-xs flex items-start gap-2 rounded ${t.cls}`} data-testid={`bi-insight-${idx}`}>
            <Icon size={16} weight="bold" className="shrink-0 mt-0.5" />
            <span>{i.text}</span>
          </div>
        );
      })}
    </div>
  );
}
